var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path975",
    d: "M0-682.665H24v24H0Z",
    transform: "translate(0 681.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Employee_2",
    "data-name": "Employee 2",
    transform: "translate(0 683.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g971",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7745",
    "data-name": "Group 7745",
    transform: "translate(0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g979",
    transform: "translate(2.333 2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path981",
    d: "M0-305.5a9.167,9.167,0,0,0,9.167,9.167,9.167,9.167,0,0,0,9.167-9.167,9.167,9.167,0,0,0-9.167-9.167A9.167,9.167,0,0,0,0-305.5Z",
    transform: "translate(0 314.666)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g983",
    transform: "translate(9.164 6.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path985",
    d: "M-198-99a2.334,2.334,0,0,1-2.334,2.334A2.334,2.334,0,0,1-202.666-99a2.334,2.334,0,0,1,2.334-2.334A2.334,2.334,0,0,1-198-99Z",
    transform: "translate(202.666 101.333)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "translate(8.18 13.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path989",
    d: "M-289.283-61.223a3.927,3.927,0,0,0-3.046-1.443h-.729a3.927,3.927,0,0,0-3.046,1.443",
    transform: "translate(296.103 62.667)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesActiveIcon);
export default __webpack_public_path__ + "static/media/Employees_Active_Icon.9576cd26fdecc4498d632cf5ccb57082.svg";
export { ForwardRef as ReactComponent };